import type { AmountMode, ColumnMap, ImportProposedMapping, OutflowSign } from '@/api/imports';
import type { ImportProfile } from '@/api/importProfiles';

export const CANONICAL_FIELDS = [
  'date',
  'amount',
  'debit',
  'credit',
  'payee',
  'memo',
  'runningBalance',
  'externalId',
] as const;

export type CanonicalField = (typeof CANONICAL_FIELDS)[number];

export const OPTIONAL_FIELDS: ReadonlySet<CanonicalField> = new Set([
  'amount',
  'debit',
  'credit',
  'memo',
  'runningBalance',
  'externalId',
]);

export interface MappingForm {
  headerRow: number;
  firstDataRow: number;
  columnMap: ColumnMap;
  amountMode: AmountMode;
  outflowSign: OutflowSign;
  dateFormat: string;
  delimiter: string;
  encoding: string;
  profileId: number | null;
}

export function formFromProposal(
  proposal: ImportProposedMapping,
  delimiter: string,
  encoding: string,
  profileId: number | null,
): MappingForm {
  return {
    headerRow: proposal.headerRow,
    firstDataRow: proposal.firstDataRow,
    columnMap: { ...proposal.columnMap },
    amountMode: proposal.amountMode,
    outflowSign: proposal.outflowSign,
    dateFormat: proposal.dateFormat,
    delimiter,
    encoding,
    profileId,
  };
}

export function formFromProfile(profile: ImportProfile): MappingForm {
  return {
    headerRow: profile.headerRow,
    firstDataRow: profile.firstDataRow,
    columnMap: { ...profile.columnMap },
    amountMode: profile.amountMode,
    outflowSign: profile.outflowSign,
    dateFormat: profile.dateFormat,
    delimiter: profile.delimiter,
    encoding: profile.encoding,
    profileId: profile.id,
  };
}

/** The 1-based file row of `sampleRows[index]`: the sample starts at the detected header. */
export function sampleFileRow(preambleRows: number, index: number): number {
  return preambleRows + 1 + index;
}
